import React from 'react'
import { GitBranch } from 'lucide-react'
import { computePortfolio } from '../utils/portfolio'
import { PRIVACY } from '../config/ondsConfig'
import { formatCurrency, formatPrice, formatPercent } from '../utils/format'
import { toneColor } from '../utils/tone'

const MASK = PRIVACY.mask

export default function ScenarioPanel({ scenarios = [], portfolio, locked = false }) {
  if (!scenarios.length) return null
  const show = !locked && !!portfolio
  const sec = (value) => (show ? value : MASK)

  const rows = scenarios.map((s) => ({
    ...s,
    metrics: show ? computePortfolio(portfolio, { price: s.price }) : null,
  }))

  const expectedNet = show
    ? rows.reduce((sum, r) => sum + r.metrics.netWorth * r.probability, 0)
    : 0

  return (
    <div className="onds-card p-5 md:p-6">
      <div className="flex items-center gap-2 mb-1">
        <GitBranch className="h-5 w-5" style={{ color: 'var(--onds-accent)' }} />
        <h2 className="text-lg font-bold">Scenarios to {sec('$10M')}</h2>
      </div>
      <p className="text-xs text-[var(--onds-text-dim)] mb-4">
        Probability-weighted net worth. Every path is judged against the one number that matters.
      </p>

      <div className="flex flex-col gap-3 mb-4">
        {rows.map((r) => (
          <div key={r.id} className="rounded-xl p-3" style={{ backgroundColor: 'var(--onds-surface)' }}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <span className="text-sm font-bold" style={{ color: toneColor(r.tone) }}>{r.label}</span>
                <span className="text-xs text-[var(--onds-text-dim)]">@ {formatPrice(r.price)}</span>
                <span className="onds-chip" style={{ color: 'var(--onds-text-dim)' }}>{formatPercent(r.probability, 0)} odds</span>
              </div>
              <span className="text-sm font-bold tabular-nums" style={{ color: toneColor(r.tone) }}>
                {sec(formatCurrency(r.metrics?.netWorth))}
              </span>
            </div>
            <div className="h-2 rounded-full overflow-hidden mb-2" style={{ backgroundColor: 'var(--onds-border)' }}>
              <div className="h-full rounded-full" style={{ width: `${Math.max(show ? 2 : 0, (r.metrics?.goalProgress ?? 0) * 100)}%`, backgroundColor: toneColor(r.tone) }} />
            </div>
            <p className="text-xs text-[var(--onds-text-dim)]">{r.note} · {sec(formatPercent(r.metrics?.goalProgress ?? 0, 0))} of goal</p>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between rounded-xl p-3" style={{ backgroundColor: 'var(--onds-bg)', border: '1px dashed var(--onds-border)' }}>
        <span className="text-sm text-[var(--onds-text-dim)]">Expected net worth</span>
        <span className="text-lg font-bold tabular-nums" style={{ color: 'var(--onds-accent)' }}>{sec(formatCurrency(expectedNet))}</span>
      </div>
    </div>
  )
}
